import React from "react" 
import ImageMeta from "../components/ImageMeta"
import Layout from "../components/layout"
import Seamless from "../components/Seamless"
import { SharedStateProvider } from "../components/SharedState/PageSharedState"

import TheaterVideo from "../components/Theater/TheaterVideo"
import Button from '@bit/azheng.joshua-tree.button';
import HeadingParagraphButton from "../components/CTA/HeadingParagraphButton"
import { Link, graphql } from "gatsby"
import { instructions } from "../cms/collections/instructions"

import SEO from "../components/seo"

var classNames = require("classnames")

function createHtml(html) {
  return { __html: html }
}
var showdown = require("showdown")
const converter = new showdown.Converter()

function sortArchive(archiveArray) {
  archiveArray.sort((a, b) => (a.order > b.order ? 1 : -1))
}

function InstructionItem(props) {
  var youtube = props.youtube

  return (
    <div className="columns instructions-block-wrapper">
      <div className="column is-3"></div>
      <div className="column instructions-block">
        <div className="left-is-1 right-is-1">
          <div className="columns is-vcentered">
            <div className="column">
              <h4 className="operative-subheading">
                {props.preOrPost === "pre" ? "Pre-Operative" : "Post-Operative"}
              </h4>
              <h5 className="operative-heading">
                {props.instructionBlockHeading}
              </h5>
            </div>
            <div className="column" align="right">
              <div className="button-group-wrapper">
                <div className="button-group float-right">
                  {youtube && (
                    <TheaterVideo
                      videoUrl={`http://youtube.com/watch?v=${youtube}`}
                      playing
                      onlyButton
                    />
                  )}

                  <Button
                    buttonText="Learn More"
                    href={"/" + props.url}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="column is-3"></div>
    </div>
  )
}

const PatientInstructionsPage = ({ data }) => {
  var instructionsData = data.allInstructionsJson.nodes
  const post = data.allUniquePagesJson.nodes[0];
  sortArchive(instructionsData)

  var instructionsPre = instructionsData.map(instruction => {
    if (instruction.preOrPost === "pre") {
      return (
        <InstructionItem
          preOrPost={instruction.preOrPost}
          url={instruction.title}
          name={instruction.name}
          youtube={instruction.youtube}
          instructionBlockHeading={instruction.instructionBlockHeading}
        />
      )
    }
  })

  var instructionsPostsWithVideo = instructionsData.map(instruction => {
    if (instruction.preOrPost === "post" && instruction.youtube) {
      return (
        <InstructionItem
          preOrPost={instruction.preOrPost}
          url={instruction.title}
          name={instruction.name}
          youtube={instruction.youtube}
          instructionBlockHeading={instruction.instructionBlockHeading}
        />
      )
    }
  })

  var instructionsPostsNoVideo = instructionsData.map(instruction => {
    if (instruction.preOrPost === "post" && !instruction.youtube) {
      return (
        <InstructionItem
          preOrPost={instruction.preOrPost}
          url={instruction.title}
          name={instruction.name}
          youtube={instruction.youtube}
          instructionBlockHeading={instruction.instructionBlockHeading}
        />
      )
    }
  })

  return (
    <SharedStateProvider>
      <Layout>
      <SEO title={post.metaTitle} description={post.metaDescription} />
        <div className="joshua-tree-content ">
          <div className="columns top-section text-section">
            <div className="column">
              <div className="columns is-mobile">
                <div className="column is-5"></div>
                <div className="column">
                  <div>
                    <h1>Instructions</h1>
                  </div>
                </div>
              </div>
              <div className="columns">
                <div className="column is-4"></div>
                <div className="column is-16" dangerouslySetInnerHTML={createHtml(
                    converter.makeHtml(post.topBlurb)
                  )}></div>
                <div className="column is-4"></div>
              </div>
            </div>
          </div>
          <section className="body-sections section instructions-body">
            <div className="columns operative-text-section">
              <div className="column">
                <div className="columns">
                  <div className="column is-4"></div>
                  <div className="column">
                    <h4>Before Your Surgery</h4>
                    <h3>Pre-Operative Instructions</h3>
                    <div dangerouslySetInnerHTML={createHtml(
                    converter.makeHtml(post.preOpBlurb)
                  )}></div>
                  </div>
                  <div className="column is-6"></div>
                </div>
              </div>
            </div>
            <div className="pre-op-instructions-wrapper">{instructionsPre}</div>
            <div className="columns operative-text-section">
              <div className="column">
                <div className="columns">
                  <div className="column is-4"></div>
                  <div className="column">
                    <h4>After Your Surgery</h4>
                    <h3>Post-Operative Instructions</h3>
                    <div dangerouslySetInnerHTML={createHtml(
                    converter.makeHtml(post.postOpBlurb)
                  )}></div>
                  </div>
                  <div className="column is-6"></div>
                </div>
              </div>
            </div>
            <div className="post-op-instructions-wrapper">
              {instructionsPostsWithVideo}
              {instructionsPostsNoVideo}
            </div>
            <div>
              <HeadingParagraphButton
                sideColumnIs={5}
                heading={post.getStarted.heading}
                paragraph={post.getStarted.blurb}
                buttonText={post.getStarted.buttonText}
                buttonUrl={post.getStarted.href}
              />
            </div>
          </section>
        </div>
      </Layout>
    </SharedStateProvider>
  )
}

export const pageQuery = graphql`
  query instructionsEs ($loneUrl: String!) {
    allInstructionsJson {
      nodes {
        title
        name
        preOrPost
        youtube
        instructionBlockHeading
        order
      }
    }
    allUniquePagesJson(filter: {title: {eq: $loneUrl}}) {
      nodes {
        title
        metaTitle
        metaDescription
        heading
        topBlurb
        preOpBlurb
        postOpBlurb
        getStarted {
          blurb
          buttonText
          heading
          href
          subheading
        }
      }
    }
  }
`

export default PatientInstructionsPage
